import ReactDOM from 'react-dom';
import ownerDocument from 'dom-helpers/ownerDocument';
export default function (componentOrElement) {
  return ownerDocument(ReactDOM.findDOMNode(componentOrElement));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-overlays/esm/utils/ownerDocument.js
// module id = 8863
// module chunks = 0